import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _BaseGuidedExpressionEditor;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { ExpressionLoading } from "abreact/expression/ui/editor/impl/utils/ExpressionLoading";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { Assert } from "abweb/utils/Assert";
import { AbMaybePromise } from "abweb/utils/async/AbMaybePromise";
import { action, makeObservable, observable } from "mobx";
import * as React from "react";
export let BaseGuidedExpressionEditor = (_dec = observable.ref, _dec2 = action.bound, _class = (_BaseGuidedExpressionEditor = class BaseGuidedExpressionEditor extends React.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "_model", _descriptor, this);
    _defineProperty(this, "_modelSequencer", new AbMaybePromise.Sequencer());
    _defineProperty(this, "_applyPromise", Promise.resolve());
    _defineProperty(this, "_expExpressionDefinition", void 0);
    this.applyModel = this.applyModel.bind(this);
    makeObservable(this);
  }
  setModel(model) {
    this._model = model;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: CssUtils.composeClassNames(BaseGuidedExpressionEditor.CLASS_NAME, this.props.className)
    }, this._model == null ? /*#__PURE__*/React.createElement(ExpressionLoading, null) : this.guidedExpressionEditor);
  }
  componentDidMount() {
    this.updateModelFromExpExpressionDefinition(this.props.expExpressionDefinition);
  }
  componentDidUpdate(previousProps) {
    if (Expression.Definition.equals(previousProps.expExpressionDefinition, this.props.expExpressionDefinition)) {
      return;
    }
    if (Expression.Definition.equals(this._expExpressionDefinition, this.props.expExpressionDefinition)) {
      return;
    }
    this.updateModelFromExpExpressionDefinition(this.props.expExpressionDefinition);
  }
  updateModelFromExpExpressionDefinition(expExpressionDefinition) {
    const {
      modelMediator
    } = this.props;
    if (expExpressionDefinition != null) {
      const modelMaybePromise = this._modelSequencer.sequence(modelMediator.import(expExpressionDefinition));
      AbMaybePromise.map(modelMaybePromise, this.setModel);
    } else {
      const modelMaybePromise = this._modelSequencer.sequence(modelMediator.createDefault());
      if (this.props.isReadonly) {
        AbMaybePromise.map(modelMaybePromise, this.setModel);
      } else {
        this.applyModel(modelMaybePromise, {
          frameworkInitiated: true
        });
      }
    }
  }
  applyModel(modelMaybePromise, context) {
    Assert.assert(!this.props.isReadonly);
    const {
      modelMediator,
      onChange
    } = this.props;
    // Due to the long promise chain below here, we sequence model applications so only one can happen at a time.
    this._applyPromise = this._applyPromise.then(() => AbMaybePromise.map(modelMaybePromise, model => {
      if (model !== this._model) {
        this.setModel(model);
        return AbMaybePromise.map(modelMediator.export(model), expExpressionDefinition => {
          this._expExpressionDefinition = expExpressionDefinition;
          return onChange(expExpressionDefinition, {
            ...context,
            model
          });
        });
      }
    }));
    this.props.changeTracker?.track(this._applyPromise);
  }
}, _defineProperty(_BaseGuidedExpressionEditor, "CLASS_NAME", "ab-gee"), _BaseGuidedExpressionEditor), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_model", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setModel", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "setModel"), _class.prototype), _class);
//# sourceMappingURL=BaseGuidedExpressionEditor.js.map
